<div class="header">
  <h2
    nuiTypography="nui-title"
    uiSize="lg">
    Notifications
  </h2>
  <div class="actions">
    @if (hasUnreadNotifications()) {
      <ui-button
        nuiType="plain-primary"
        size="sm"
        (click)="markAllAsRead()">
        Mark all as read
      </ui-button>
      <ui-divider direction="vertical" />
    }
    <ui-toggle-switch
      [selected]="!isShowingAll()"
      (selectedChange)="setUnreadFilter($event)"
      size="sm"
      label="Only unread" />
  </div>
</div>
